module.exports = __webpack_public_path__ + "static/water_glacier7-1781e3d4d448474cdb2b05617b0eda53.jpg";